'use client'

import React, { FC, ReactElement } from 'react'
import styles from './WalletBalanceXverse.module.css'
import WalletDetailCard from '../../wallet-detail-card'
import abbreviateAddress from '@/utils/abbreviate-address'
import Wallet from '@/utils/wallet'
import classNames from 'classnames'
import copy from '@/utils/copy'

const WalletBalanceXverse: FC = (_props): ReactElement => {
	return (
		<div className={styles.root}>
			<WalletDetailCard
				detailName="ORDINALS ADDRESS"
				value={abbreviateAddress(Wallet.getTaprootAddress())}
				detailNameClass={classNames('text-xs', 'regular')}
				valueClass={classNames('text-md', 'regular')}
				className={styles.paymentsAddress}
				onClick={() => copy(Wallet.getTaprootAddress())}
			/>
			<WalletDetailCard
				detailName="PAYMENTS ADDRESS"
				value={abbreviateAddress(Wallet.balanceAddress())}
				detailNameClass={classNames('text-xs', 'regular')}
				valueClass={classNames('text-md', 'regular')}
				className={styles.ordinalsAddress}
				onClick={() => copy(Wallet.balanceAddress())}
			/>
		</div>
	)
}

export default WalletBalanceXverse
